import type { HistogramChartXAxisProps } from '../types/histogram.js';

export const XAxis = (props: HistogramChartXAxisProps) => null;

XAxis['displayName'] = 'HistogramChart.XAxis';
